import { useEffect } from "react";
import { Input, Form } from "antd";
import { getLangList } from '@/lib/i18n';
import { modalFromLayout } from "@/lib/antdElementFunction";
import { ExamType } from './types';

interface Props {
  form: any;
  info: ExamType;
  handleType: string;
}

function ModalExam(props: Props) {
  const { form, info, handleType } = props;
  const semesterT: any = getLangList("semester");

  useEffect(() => {
    const { examName } = info ?? {};

    handleType === 'updateExam' && form.setFieldsValue({ examName });
  }, [form, info, handleType]);

  return (
    <Form
      className="admin-form"
      style={{ marginTop: 20 }}
      {...modalFromLayout}
      form={form}
    >
      <Form.Item
        label={semesterT.EXAM}
        name="examName"
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>
    </Form >
  );
}

export default ModalExam;